import React from 'react';
import { SECTION_ID } from './ContactCollectorSection.constants';
import {
  CollectAddressButton,
  EyebrowWrapper,
  LottieContainer,
  StyledSection,
  StyledTextPairing,
  TextContainer,
  LearnMoreButton,
  ButtonWrapper,
  VideoContainer,
} from './ContactCollectorSection.styles';
import { NewFlag } from '@components/NewFlag';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { VimeoVideo } from '@components/VimeoVideo';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { useTranslation } from 'react-i18next';

export const ContactCollectorSection = () => {
  const isMobile = useThemeMediaQuery('below_sm');
  const { t } = useTranslation('home');
  const { eyeBrow, title, body, linkTextPrimary, linkPrimary, linkTextSecondary, linkSecondary } = t('contactCollector');
  const videoAssets = t('contactCollectorVideos');
  const currentVideoAssets = isMobile ? videoAssets.mobile : videoAssets.desktop;

  return (
    <StyledSection as="section" id={SECTION_ID} marginX={[0, 6]} marginBottom={6}>
      <TextContainer paddingY={[8, 0]}>
        <LottieContainer flexDirection="column" justifyContent={['flex-start', 'center']} alignItems={['center', 'flex-start']}>
          <EyebrowWrapper>
            <NewFlag
              flagColor="white"
              flagBackgroundColor="accentBlue4"
              belowSm={{ flagColor: 'white', flagBackgroundColor: 'accentBlue4' }}
              title={eyeBrow}
              titleColor="accentBlue4"
              titleVariant="sectionEyeBrow18"
              size={80}
            />
          </EyebrowWrapper>
          <StyledTextPairing
            titleVariant="calloutHed40Bold"
            titleColor="mono1"
            titleTagName="h3"
            title={title}
            body={body}
            bodyVariant="dek20"
            bodyColor="mono12"
            marginBottom={7}
            alignment={['center', 'left']}
            textAlign={['center', 'left']}
          />
          <ButtonWrapper>
            <CollectAddressButton id="collectAddressBtn" forwardedAs="a" href={linkPrimary} variant="secondaryMono" rounded>
              {linkTextPrimary}
            </CollectAddressButton>
            <LearnMoreButton id="learnMoreBtn" forwardedAs="a" href={linkSecondary} variant="ghostMono" rounded iconRight="forwardChevron">
              {linkTextSecondary}
            </LearnMoreButton>
          </ButtonWrapper>
        </LottieContainer>
      </TextContainer>
      <VideoContainer>
        <LazyLoadWrapper>
          <VimeoVideo
            title={title}
            embedUrl={currentVideoAssets.url}
            posterUrl={currentVideoAssets.poster}
            autoPlay
            background
            muted
            controls={false}
            loop
            autoPause={false}
            cover
            posterOptimization="mild"
            aspectRatio={0.385}
            alt="contact-collector"
          />
        </LazyLoadWrapper>
      </VideoContainer>
    </StyledSection>
  );
};
